/* eslint-disable @typescript-eslint/no-explicit-any */
import img from '../../assets/mtp-logo-primary-2026.png';
import logoLight from '../../assets/mtp-logo-secondary-2026.png';
import signinImage from '../../assets/mtp-logo-primary-2026.png';
import signinImageLight from '../../assets/mtp-logo-secondary-2026.png';
//import signinImage from '../../assets/idea.png';

export const LocalStorange = {
    USERINFO: 'x-auth-bizsphere',
};

export const applicationInfo = {
    organizationName: 'MTP Brazil',
    applicatioName: 'Talent AI',
    applicationUrl: 'www.dev.azure.com/mtpdevops',
};

//export const applicationInfo = {
//    organizationName: 'BizSphere',
//    applicatioName: 'BizSphere Solution',
//    applicationUrl: 'www.dev.azure.com/plenuscontrol',
//};

/*eslint indent: [2, 4, {"SwitchCase": 1}]*/
export function environment() {
    const env = window.location.hostname;
    const getBaseUrl = () => window.location.protocol === 'https:' ? window.location.origin : 'http://' + env + ':3300';

    const environment = {
        signinImage: signinImage,
        signinImageLight: signinImageLight,
        logo: img,
        logoLight: logoLight,
        backgroundSize: '42%',
        // backgroundSize: '100%',
        backgroundColor: '',
        // opacity: .4,
        opacity: 1,
        applicationTitle: '',
        applicatioName: '',
        baseUrl: '',
        authBaseUrl: '',
        xapikey: '',
        name: '',
    };

    switch (env) {
        case 'localhost':
            environment.applicatioName = applicationInfo.applicatioName;
            environment.applicationTitle = applicationInfo.applicatioName + ' | ' + applicationInfo.organizationName;
            environment.baseUrl = 'http://' + env + ':3300';
            environment.xapikey = '';
            environment.name = 'Localhost - Development v1.0';
            break;

        case 'bizsphere.mtp.com.br':
            environment.applicatioName = applicationInfo.applicatioName;
            environment.applicationTitle = applicationInfo.applicatioName + ' | ' + applicationInfo.organizationName;
            environment.baseUrl = getBaseUrl();
            environment.xapikey = '';
            environment.name = 'Production';
            break;

        case 'talent.mtp.com.br':
        case 'www.talent.mtp.com.br':
            environment.applicatioName = applicationInfo.applicatioName;
            environment.applicationTitle = applicationInfo.applicatioName + ' | ' + applicationInfo.organizationName;
            environment.baseUrl = 'https://talent.mtp.com.br';
            environment.xapikey = '';
            environment.name = 'Production';
            break;

        case 'bizsphere-homolog.mtp.com.br':
            environment.applicatioName = applicationInfo.applicatioName;
            environment.applicationTitle = applicationInfo.applicatioName + ' | ' + applicationInfo.organizationName;
            environment.baseUrl = getBaseUrl();
            environment.xapikey = '';
            environment.name = 'Homologation';
            break;

        case '50.19.82.136':
            environment.applicatioName = applicationInfo.applicatioName;
            environment.applicationTitle = applicationInfo.applicatioName + ' | ' + applicationInfo.organizationName;
            environment.baseUrl = getBaseUrl();
            environment.xapikey = '';
            environment.name = 'Production';
            break;

        case '192.168.1.215':
            environment.applicatioName = applicationInfo.applicatioName;
            environment.applicationTitle = applicationInfo.applicatioName + ' | ' + applicationInfo.organizationName;
            environment.baseUrl = 'http://' + env + ':3300';
            environment.xapikey = '';
            environment.name = 'localhost';
            break;

        case '34.201.36.212':
            environment.applicatioName = applicationInfo.applicatioName;
            environment.applicationTitle = applicationInfo.applicatioName + ' | ' + applicationInfo.organizationName;
            environment.baseUrl = getBaseUrl();
            environment.xapikey = '';
            environment.name = 'Production';
            break;

        default:
            environment.applicatioName = applicationInfo.applicatioName;
            environment.applicationTitle = applicationInfo.applicatioName + ' | ' + applicationInfo.organizationName;
            environment.baseUrl = getBaseUrl();
            environment.xapikey = '';
            environment.name = '';
            break;
    }

    startSettings(environment);

    return (
        environment
    );
}

const startSettings = (environment: any) => {
    window.document.title = environment.applicationTitle;

    let link = document.querySelector('link[rel~="icon"]') as HTMLLinkElement;

    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    link.href = '/favicon.ico';
};

export const ListId = {
    companyId: '620ADDB5-6270-4F39-8703-FFB545E59A80',
    applicationTypeId: '29E29C3A-7FD9-4601-9AF9-356FB41DAE24',
    attributeActionId: '7E460D4A-83D5-4F40-84F8-E305AD61DF69',
    identificationTypeId: 'D5C8CAFE-E53D-4E1C-87E2-7A97D5ABDEC4',
    testLevel: '479295C0-04B5-47F0-8691-5552ACA3F828',
    executionStatus: 'D57FD62E-2D46-4F5F-A59F-465C04D2C35F',
    availableStatus: '7E460D4A-83D5-4F40-84F8-E305AD61DF69',

    masterCompanyId: '2201fec7-7c95-4eba-a19f-06d80033609d',
    corpsphere: {
        companyId: 'f64d6fa1-9b09-46f2-90a0-5ad97135e6de',
        pleopleId: '57d749ab-0909-467b-98b9-ae1182a8ca70',
        companyPeopleAssociateId: '250cba83-a3c1-467e-94ab-0c094715c16d',
        departmentId: 'efe152ab-ec29-49fc-8885-0a85e30e9b15',
        company: {
            statusIdStart: '',
            unityTypeIdStart: '',
            statusId: 'b9dba9fa-e88a-42e9-956f-9504735e3c5a',
            status: {
                new: '9e0efaea-ca84-4d07-b1cf-9b915cacc81a'
            },
            statusIdInternal: '046c2c99-1218-43ee-bb9c-341b0551bc2c',
            businessRelationshipTypeId: 'bb2e1c8d-080b-4cf9-8fad-bba3781fc551',
            businessRelationshipType: {
                businessPartner: 'df6d5a53-4804-4eef-9bee-8a798127bdaa',
                customer: '42d4d3d9-47c9-4366-855c-d9891875ff84',
                productSupplier: 'e047391d-d8e8-42a7-a394-10618ace562c',
                prospection: '7ec11fc9-7926-41cf-a83d-c9198f2e95d9',
                serviceProvider: '13b03d94-f4dc-4834-ac3e-a0eb71248903',
            },
            mainActivityId: '5b245fd2-a9eb-49f6-bb85-226a6a1911ef',
            unityTypeId: '5820c7c9-3419-4b87-a187-39d5c462a199'
        },
        people: {
            typeId: '9a41c636-77f0-4bbf-9389-a8cb6b997827',
            type: {
                serviceAccount: '7461ce81-87fa-4841-a1c8-b061bb032114'
            },
            statusId: '91e85af4-53dd-48d5-af70-01dc439505a1',
            jobTitle: '98021035-4907-426e-95f9-a0d0593a0a6a'
        },
        opening: {
            salesPerspective: '38ec8829-40d8-43aa-98e1-ec50f05c06b3'
        },
        product: {
            printTypeId: 'cd21c3a9-2a58-483a-833c-a477f603b96a',
            objectiveId: 'b71676ad-5e89-4efc-b8fb-ce7bd32fabd4',
            lineId: '4749d0d8-634b-4e06-9c58-6f9171c8dd22',
            penetrationId: '9cbd9e50-4df2-42be-b952-7e84a0cb1fd4',
            screenAniloxNumberId: '82b5dba8-c113-44fc-8441-b3947358280e',
            supportId: '07275300-0bec-4486-8b35-e23b9d73b4f8',
            enduranceId: 'ae5ced25-a3ca-47df-99e4-37670e58bc9f',
            reactionId: 'dbccf177-4580-419d-a70d-e50bead64ee0',
        }
    },
    appsphere: {
        applicationId: '553fc317-0e9c-4d46-b9c2-f136e5cb670f',
        featureId: '05761f7f-b455-4cd0-a08d-ac0ec20bc956',
        attributeId: '4d5cf2f2-08f9-4359-acfa-8a882544e007',
        application: {
            typeId: 'a3c2c77f-3dc2-4e65-8cce-6ab8eeffb4fd'
        },
        attribute: {
            actionId: '7E460D4A-83D5-4F40-84F8-E305AD61DF69',
            attributeActionClickId: '1fc2bd91-5305-4156-a9fd-2382644496de',
            identificationtypeId: 'b1c0a356-f3bb-45fa-ad69-1b624fc656ce'
        }
    },
    clientsphere: {
        oportunityId: '0a8fe0a0-3e26-40f9-8e51-40be2c26e2aa',
        oportunity: {
            statusId: 'fe6df83b-2f47-45c8-b267-21f7d078b186',
            startStatus: '9a0d6a79-20f8-4ac7-9893-53d9d97bab8d',
            sourceId: 'bcd25e64-5226-4a1f-b7b1-ba182fb50c62',
            priorityId: '4dfd06d4-9c78-4669-88e6-0b7cf67468cf'
        }
    },
    worksphere: {
        demandId: 'e8358f60-3303-11ef-80fb-0242ac12000d',
        workItemId: '9a9de509-6e03-4bab-b3da-19028cd1e420',
        demand: {
            categoryId: 'ed4613c9-85af-4869-b043-deb848ba2925',
            typeId: '6a530edb-6350-4ffb-b964-c7abbe2eb151',
            priorityId: 'd3fdceda-ff61-4779-be08-3bae9e13a7fb',
            statusId: '4b1f33b2-ecba-47cd-a382-9e30e2060047',
            startStatus: '98576928-b88b-4eb2-b925-389db61f647b',
        },
        workItem: {
            statusId: '',
            startStatus: '',
            typeId: ''
        }
    },
    talentsphere: {
        vacancyId: '4fa78155-f4dd-43e7-a340-e0276ddc9e55',
        resumeId: 'd39d8f53-6659-48f3-bb5a-1c11f6c50b4d',
        resumeVacancyId: 'ecc86fcd-326d-4efd-b0d7-b744d2ac2544',
        interviewId: 'aa7f8bc0-1ca4-4a2f-83d9-7e79bfe68450',
        resume: {
            statusId: 'b76ceb50-6109-4160-a818-79b52eda20f3',
            availableStatuId: 'c58c84b6-46ba-44d6-9628-db776869f6ad',
            competingForTheVacancy: 'c5e31b73-ce22-410c-bad7-d1ea4a7e4e2a',
            unvailableStatusId: 'd898ba55-6db2-480a-acf8-b483e72130c0',
            jobTitleId: '98021035-4907-426e-95f9-a0d0593a0a6a',
            seniorityId: 'ceed05c7-8b13-43f7-8ee3-7ce0bc803daf',
            startJobTileId: 'c8a7f1ef-23bb-4516-a64f-32accd42531c',
            sourceId: '0d5d425a-857f-4fcd-b527-11700a65356a',
            startSourceId: 'cd59f68f-577b-4c5e-9ed2-b6ea219cf500',
        },
        vacancy: {
            jobTitleId: '98021035-4907-426e-95f9-a0d0593a0a6a',
            jobTitle: {
                recruitmentManagerId: 'c299cb99-6dba-4cf9-aa1a-3a78841aee51',
                recruiterId: '9c868720-21b2-45b7-abf6-639feceef9ab',
                accountServiceManagerId: '1d3e3982-d54d-4aa6-bcb8-eb860d272910'
            },
            seniorityId: 'ceed05c7-8b13-43f7-8ee3-7ce0bc803daf',
            statusId: '37492460-4f22-4e5d-bba3-b54527d9d40f',
            status: {
                newRequestId: 'f3eeca51-f0e4-4281-bd40-a8ee767138e4',
                inProgress: 'cab66f1e-f3cb-4ab3-85fe-6c27ec741257',
                hiredId: '1d33396d-011c-4236-b788-4583c6b3191b',
                canceledByContractorId: 'ea91f2a8-fa9e-4705-ae5e-bac7087769fd',
                suspendedByContractorId: 'c9ac688a-878d-4139-9362-4ac0691a2720',
                lostId: '23a3a8a5-eba1-44b8-8ba5-b723956f1464'
            },
            typeId: '1b140e46-e517-4554-9efa-c5f19673f432',
            executionTypeId: '96118cfa-a032-411e-a4c5-20c0e9de8bb5',
            hiringTypeId: 'c07f008c-0122-4e18-ba11-ae7604fad322',
            workTypeId: 'e517bce4-890d-4e9e-bf43-465eae50324c',
            contractPeriodId: '96164064-a37f-4799-90f4-d92ab821b421',
            serviceLocalId: '9bd55fa4-4fd8-437c-9ad6-6eb704189cf7',
            frequencyId: '7ba20f48-1eb7-407e-bf82-1034f93cb39e',
            serviceTypeId: 'ada94d69-d80c-4030-91d3-6b8013fb4db1'
        },
        resumeVacancy: {
            statusId: 'e32fc6eb-f795-49e7-8f7b-e94028b23d2d',
            statusStartId: '9bc63cc6-4d64-4262-b106-eb315bf3dbbb',
            customerStatusId: 'b3b12c1e-396b-4467-9c50-a84fc7509ace',
            customerStatusStartId: 'f4a6341d-68f9-4c17-9082-9d4fb6bbd79b'
        },
        interview: {
            typeId: '7cdf109e-5414-45d1-a5ec-31ae1baa3c1b',
            statusId: '345fd84d-e7bf-4ce0-a742-f4c0c05be626',
            statusApprovedId: '024701ea-dc4e-4809-a8ff-ba8528e89f57',
            statusRepprovedId: '81e5b6f4-5c7c-4b45-a4c9-296fb0b3e861',
            reasonId: '487338f1-f7c1-4a04-aa02-b9aa4d1b3bbc'
        },
        associatedSkill: {
            typeId: '75f42760-89af-4950-a62c-32c048225a9f',
            hardSkillId: 'f17bb9fc-e4bf-4193-9f40-39e9e0ef3db2',
            softSkillId: 'a90796e4-cda8-45f3-a419-46c8875c5eca',
            expertiseId: '881747e8-587d-400e-b2ef-1583ecce31c4',
            languageId: '8bfd666f-bf00-47f7-bc19-4a5cd8f3360a',
            languageLevelId: '84177334-4fdd-4c2e-b407-4937c5f676ff'
        },
    },
    testingsphere: {
        testpackage: {
            testlevel: '94b8d8f0-b9f6-44b1-a787-ded17b622e65',
            executionstatus: '64aee908-0617-454c-afb4-ce550d85c32b',
            statusId: '999fc553-db55-4580-a347-f5dbd59a73cd',
            statusidstart: '2c5be881-b500-4768-ab40-d1e83c34eda2',
            executionstatusstart: 'fdab2784-f6d5-48f0-b537-b4d1b9ef9d30' //no run
        },
        testagent: {
            status: '2e521201-de54-40db-b9eb-c4937c146eb5'
        },
        testacceptancecriteria: {
            condition: '4053c677-578b-4126-8bdc-83fbe228ec49'
        },
        defect: {
            statusId: '1b3c4e06-0794-4de8-bdf3-158b1c0b1e90',
            startstatusId: 'b13c1698-7ed3-49d4-9d61-3ec316c85e96',
            priorityId: '0363103b-234a-49e8-8378-629b450ad96e',
            severityId: 'd60a1f1a-12dd-4626-ba87-174ff9a48254',
            typeId: '168988f3-9733-4ad3-a22b-19a29018edb1'
        }
    },
    linksphere: {
        integration: {
            statusId: 'ed5ffc2d-749d-45de-9d7a-4e159a8f57c4',
            startStatusId: '997779a8-7613-4d1e-9fc2-270d508816c6'
        },
        message: {
            statusId: 'a6ca696b-15cf-4a9f-8ddd-a413eb47309b',
            startStatusId: '464dc7fb-9c06-4771-960f-223e4409d47b',
            flowId: 'f1176bff-cb25-4454-88a6-05881ffd68d0'
        },
        integrationSetting: {
            flowId: '67f693ec-1825-4a3e-ae64-7e4ffee2f2a9',
            integrationTypeId: '8716e0f7-47e6-464d-b7fb-3b206e0a6156'
        },
        integrationParameter: {
            typeId: '7eb813c1-5bcc-4d3b-af5f-6c66130b623b'
        }
    },
    authsphere: {
        userId: '27cdb3c7-dd81-4293-9931-00f1e5aa0184',
        userGroupId: '2160a250-923c-4b15-926f-60f8ddbbe99d',
        userGroupUserId: '236ff44f-049a-4fec-bb10-65146c0b501d',
        userUserGroupId: '8cde570a-d477-4391-b643-3a753e6aedf5',
        accessRoleId: '30390371-a682-441e-a598-c7bf3d9862bb'
    },
    parmsphere: {
        listId: '25d85df4-c264-4daa-89fb-7c90efaf6a7b',
        ValueListId: '1fbb5353-76a2-4da3-8f6d-b2bcab5aa747',
        settingId: '7717151b-cf72-45b9-9dc0-8223c25b351e'
    },
    historicalSphere: {
        historicalStatus: ''
    },
    infoSphere: {
        commentId: 'e195955e-c6ec-4bed-a8cb-ce9e9addc586',
        notificationId: '01900c0d-6eb7-4273-9009-3313fe076204'
    },
    aiSphere: {
        assistantId: '4a9bf849-0a7c-4852-9016-005c677b9ada',
        apiKey: 'sk-proj-kkCcJq77KteFV2yftfMgT3BlbkFJ1MnOwHiYspnI37CBaH4y'
    },
    ListValue: {
        ExecutionStatus: {
            noRunId: '',
        },
        ActionsTest: {
            navigateId: '5b49c33e-ac47-4816-a5dd-5102f1934fcc',
            click: '1fc2bd91-5305-4156-a9fd-2382644496de',
            ClickItemGridView: 'ae1158d3-3ae7-4048-9bc1-48fe1ce99bf8',
            send: 'cf4ac79c-c180-40e5-adce-55bc08cf4237',
            submit: '569d663a-049a-4b95-a65a-e3a111f62c87',
        },
        defect: {
            status: '82FB4F0A-3FA4-4FEE-A1A9-0ADD19CA48A2',
            priority: 'D7B56B24-8C6B-4D06-A234-E68FE24C32D3',
            severity: 'BCF85F88-1692-465F-A10B-81ED0B5D1577',
        },
    },
};

export const booleanSelectList = [
    { id: 'True', name: 'True' },
    { id: 'False', Name: 'False' }
];

const variant: 'outlined' | 'standard' | 'filled' | undefined = 'outlined';

export const fieldSettings = {
    fieldVariant: variant,
};

export const StatusColor = {
    noRun: '#03a9f4',
    pending: '#b388ff',
    running: '#2196f3',
    passed: '#4caf50',
    failed: '#f44336',
    blocked: '#ffeb3b',
    warning: '#c3c0be',
    total: '#eeeeee',
    expetectedTotal: '#eeeeee'
};
